import { useEffect, useState } from "react";
import BaseModal, { ModalFooter } from "../base/BaseModal";
import CustomSelect from "../base/CustomSelect";

const AssignStaffModal = ({
    isOpen,
    onClose,
    report,
    staffOptions = [],
    loadingOptions = false,
    onSubmit,
    loading = false,
}) => {
    const [selectedUserId, setSelectedUserId] = useState("");
    const [lyDo, setLyDo] = useState("");
    const [error, setError] = useState("");
    const [lyDoError, setLyDoError] = useState("");

    useEffect(() => {
        if (isOpen) {
            setSelectedUserId(report?.id_to || "");
            setLyDo("");
            setError("");
            setLyDoError("");
        }
    }, [isOpen, report]);

    const currentUserId = report?.id_to || "";
    const currentUserName =
        report?.to_phu_trach?.ho_va_ten ||
        staffOptions.find((u) => u.id === currentUserId)?.ho_va_ten ||
        "Chưa phân công";

    const handleSubmit = () => {
        if (!selectedUserId) {
            setError("Vui lòng chọn chuyên viên xử lý");
            return;
        }
        if (selectedUserId === currentUserId) {
            setError("Chuyên viên xử lý mới phải khác người đang phụ trách");
            return;
        }
        if (!lyDo.trim()) {
            setLyDoError("Vui lòng nhập lý do chuyển xử lý");
            return;
        }
        setError("");
        setLyDoError("");
        onSubmit?.(selectedUserId, lyDo.trim());
    };

    const formatStaffLabel = (u) => {
        const name = u.ho_va_ten || u.ten_dang_nhap || "Không tên";
        return u.email ? `${name} (${u.email})` : name;
    };

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title="Chuyển chuyên viên xử lý"
            subtitle={report?.ma_phan_anh ? `Mã: ${report.ma_phan_anh}` : ""}
            size="md"
            closeOnOverlay={!loading}
            footer={
                <ModalFooter
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                    submitText="Phân công"
                    submitLoading={loading}
                    submitDisabled={loading || loadingOptions}
                />
            }
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Chuyên viên đang phụ trách
                    </label>
                    <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-700">
                        {currentUserName}
                    </div>
                </div>

                <div>
                    <label
                        htmlFor="idNguoiXuLy"
                        className="block text-sm font-medium text-gray-700 mb-1"
                    >
                        Chuyên viên xử lý mới <span className="text-red-500">*</span>
                    </label>
                    <CustomSelect
                        id="idNguoiXuLy"
                        value={selectedUserId}
                        onChange={(val) => {
                            const newId = typeof val === 'object' ? val?.target?.value : val;
                            setSelectedUserId(newId);
                            if (error) setError("");
                        }}
                        disabled={loading || loadingOptions}
                        hasError={Boolean(error)}
                        placeholder={loadingOptions ? "-- Đang tải danh sách --" : "-- Chọn chuyên viên --"}
                        options={staffOptions.map((u) => ({
                            value: u.id,
                            label: formatStaffLabel(u)
                        }))}
                    />
                    {!loadingOptions && staffOptions.length === 0 && (
                        <p className="mt-1 text-sm text-amber-600">
                            Lĩnh vực của phản ánh này chưa có cán bộ quản lý để phân công.
                        </p>
                    )}
                    {error && (
                        <p className="mt-1 text-sm text-red-600">{error}</p>
                    )}
                </div>

                <div>
                    <label
                        htmlFor="lyDoChuyenXuLy"
                        className="block text-sm font-medium text-gray-700 mb-1"
                    >
                        Lý do chuyển xử lý <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        id="lyDoChuyenXuLy"
                        value={lyDo}
                        onChange={(e) => {
                            setLyDo(e.target.value);
                            if (lyDoError) setLyDoError("");
                        }}
                        disabled={loading}
                        rows={3}
                        maxLength={1000}
                        placeholder="Nhập lý do chuyển sang chuyên viên khác..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed resize-none"
                    />
                    {lyDoError && (
                        <p className="mt-1 text-sm text-red-600">{lyDoError}</p>
                    )}
                </div>
            </div>
        </BaseModal>
    );
};

export default AssignStaffModal;
